import { combineReducers } from 'redux';

import agenda from '../../agenda/store/agenda.reducers';
import achievements from '../../core/achievements/achievements.reducers';
import data from '../../core/data/data.reducers';
import users from '../../core/users/users.reducers';
import matching from '../../matching/store/matching.reducers';
import networking from '../../networking/store/networking.reducers';
import participants from '../../participants/store/participants.reducers';
import programs from '../../programs/store/programs.reducers';
import sponsors from '../../sponsors/store/sponsors.reducers';
import workshopSessions from '../../workshop-session/store/workshopSessions.reducers';
import workshops from '../../workshops/store/workshops.reducers';
import appointments from './appointments';
import modalEntries from './modalEntries';
import registrations from './registrations';
import user from './user';

export default combineReducers({
  achievements,
  agenda,
  matching,
  data,
  user,
  users,
  sponsors,
  modalEntries,
  workshops,
  registrations,
  appointments,
  programs,
  participants,
  networking,
  workshopSessions,
});
